import { styled, Theme } from '@mui/system';

import { colors } from '../../../../../../theme';

type StyledReply = {
    theme?: Theme;
    sentByMe: boolean;
};

export const StyledReplyMessageBubble = styled('div')(
    ({ sentByMe }: StyledReply) => ({
        backgroundColor: colors.grayBlue,
        borderTopLeftRadius: sentByMe ? '16px' : 0,
        borderTopRightRadius: sentByMe ? 0 : '16px',
        borderBottomRightRadius: '16px',
        borderBottomLeftRadius: '16px',
        padding: '10px 15px 15px',
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '0',
        color: colors.midGray
    })
);

export const StyledReplyMessageOwner = styled('span')(
    ({ sentByMe }: StyledReply) => ({
        color: sentByMe ? colors.white90 : colors.yellow80,
        display: 'block',
        fontSize: '13px',
        lineHeight: '20px',
        letterSpacing: '0px',
        fontWeight: 700
    })
);
